import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureNotifications
export interface IFeatureNotifications extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_NOTIFICATIONS_DEFAULT
export const _FEATURE_NOTIFICATIONS_DEFAULT: Readonly<IFeatureNotifications & Object> = {
  displayText: NavigationPageEnumHumanReadable.Notifications,
  feature: NavigationPageEnum.Notifications,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion